import React, { Component } from "react";
import { applyDataTable } from '../../../custom/dataTable';
import Delete from '../../../../assets/img/svg/delete.svg';
import del from "../../../../assets/img/svg/Del.svg";
import $ from 'jquery';
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import styles from "../../../../assets/jss/customStyle";
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import moment from "moment"
import axios from "axios";
import API from "../../../../_helpers/endpointService";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { CssTextField, CssTextFieldLast, CssTextFieldRow } from "../../../custom/textField"
import Select from "react-select";
import closeIcon from "../../../../assets/img/svg/closeIcon.svg";
import { roleTypeString } from "../../../common/commonJson";
import { characterValidation, dropDownOptions } from "../../../common/commonFunction";

class LViewRoles extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile: false,
            render: false,
            dataList: [],
            deleteId: 0,
            showrow: false,
            responseId: 0,
            index: 0,
            actNameFocus: false,
            DescNameFocus: false,
            name: "",
            typeId: 0,
            nameError: false,
            searchData: {
                PageNumber: 1,
                PageSize: 100,
            },
            lookupData: {
                Name: "",
                PageNumber: 1,
                PageSize: 10000,
            },
            rolesValue: [],
            rolesOptions: [],
            FocusId: 0,
            FocusId1: 0,
            paging: false,
            existId: [],
            isOnChange: false,
        }
    }

    componentDidMount() {
        const { dispatch } = this.props;
        this.setState({ paging: true });
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        this.dataTable(this.state.searchData);
        this.lookupRoleData(this.state.lookupData, roleTypeString);
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    }

    dataTable = (data) => {
        let apiUrl = API.ACTION_COMMONROLES + '?PageNumber=' + data.PageNumber + '&PageSize=' + data.PageSize;
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.state.dataList = [];
                    this.setState({})
                    response.data.CommonRoles.sort((a, b) => {
                        return a.Id - b.Id;
                    });
                    this.state.dataList = response.data;
                    this.state.dataList.CommonRoles.push({
                        Id: 0,
                        Name: "",
                        TypeId: 0,
                    })
                    this.state.render = true;
                    this.setState({})
                    if (this.state.paging == true) {
                        setTimeout(
                            window.scrollTo(0, 0)
                            , 0)
                        this.setState({
                            paging: false
                        })
                    }
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    lookupRoleData = (data, type) => {
        let apiUrl = API.LOOKUP_DATA + '?Name=' + data.Name + '&Type=' + type + '&PageNumber=' + data.PageNumber + '&PageSize=' + data.PageSize;
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.setState({
                        rolesOptions: dropDownOptions(response?.data?.Values)?.props?.children
                    })
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    componentWillUnmount() {
        clearInterval(this.interval);
        $("#MASDATA8 .MuiListItemText-primary").addClass("spanTopBar")
        $("#MasterData8 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#MasterData88").addClass("d-none");
        $("#MasterData88").removeClass("d-block");
        $("#MRoles").removeClass("active-color");
        $("#MRolesT").removeClass("fw-bolder");
    }

    sidebar = () => {
        this.props.navigate("/sidebarmasterdata");
    }

    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        $("#MASDATA8 .MuiListItemText-primary").addClass("spanTopBar")
        $("#MasterData8 .MuiListItemText-primary").addClass("fw-bolder");
        $("#MasterData88").removeClass("d-none");
        $("#MasterData88").addClass("d-block");
        $("#MRolesT .MuiListItemText-primary").addClass("fw-bolder");
        $("#MRoles").addClass("active-color");
    };

    post_data = (data) => {
        let apiUrl = API.ACTION_COMMONROLES;
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.dataTable(this.state.searchData);
                    this.state.dataList.CommonRoles.map((i) => (
                        i.Id == 0 ? (i.Id = response.data, i.Name = this.state.name, i.TypeId = this.state.typeId) : <></>
                    ))
                    this.setState({})
                    this.setState({
                        name: "",
                        typeId: 0,
                    })
                    this.state.nameError = false;
                    this.state.FocusId = 0;
                    this.state.FocusId1 = 0;
                    let id = this.state.dataList.CommonRoles.filter((i) => i.Id == 0)
                    if (id.length == 0) {
                        this.state.dataList.CommonRoles.push({
                            Id: 0,
                            Name: "",
                            TypeId: 0
                        })
                    }
                    this.state.dataList.CommonRoles.sort((a, b) => {
                        return a.Id - b.Id;
                    });
                    this.setState({})
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    put_data = (data, Id) => {
        let apiUrl = API.ACTION_COMMONROLES + '/' + Id;
        axios({
            method: "PUT",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.dataTable(this.state.searchData)
                    this.setState({ FocusId1: 0 })
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    OpenPopup = (Id) => {
        this.state.deleteId = Id;
        this.setState({})
        window.$("#deletepopup").modal("show")
    }

    DeleteItem = () => {
        window.$("#deletepopup").modal("hide");
        this.deleteopalookdocs(this.state.deleteId)
    }

    deleteopalookdocs = (data) => {
        let apiUrl = API.ACTION_COMMONROLES + '/' + data;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "delete",
            url: apiUrl,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    let data = {
                        Name: "",
                        PageNumber: 1,
                        PageSize: 100,
                    };
                    this.setState({
                        searchData: data,
                    })
                    this.dataTable(data)
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {

                }
            });
    };

    hoverHeight = (e, i) => {
        let data = $("#actName" + i.Id).val()?.match(/\r?\n/g)?.length ? $("#actName" + i.Id).val()?.match(/\r?\n/g)?.length : 0;
        let data1 = $("#actDesc" + i.Id).val()?.match(/\r?\n/g)?.length ? $("#actDesc" + i.Id).val()?.match(/\r?\n/g)?.length : 0;
        this.state.HoverId = i.Id;
        if (data > data1) {
            this.state.Rows = data + 1;
        }
        else {
            this.state.Rows = data1 + 1;
        }
        this.setState({})
    }

    hoverHeight1 = (e, i) => {
        let data = $("#actName" + i.Id).val()?.match(/\r?\n/g)?.length ? $("#actName" + i.Id).val()?.match(/\r?\n/g)?.length : 0;
        let data1 = $("#actDesc" + i.Id).val()?.match(/\r?\n/g)?.length ? $("#actDesc" + i.Id).val()?.match(/\r?\n/g)?.length : 0;
        this.state.FocusId = i.Id;
        if (data > data1) {
            this.state.Rows1 = data + 1;
        }
        else {
            this.state.Rows1 = data1 + 1;
        }
        this.setState({})
    }

    handleInputChange1 = (e, str, val, index) => {
        this.setState({
            isOnChange: true
        })
        if (val == "Name") {
            if (characterValidation(e.target.value) == true) {
                this.state?.dataList?.CommonRoles?.map((i) => (
                    i.Id == str.Id ? i.Name = e.target.value : <></>
                ))
            }
            if (e.target.value != "") {
                let index = this.state.existId.filter(item => item !== str.Id);
                this.setState({
                    existId: index
                })
            }
        }
        this.setState({})
    }

    handleRoleNameChange = (e) => {
        this.setState({
            isOnChange: true,
        })
        if (characterValidation(e.target.value) == true) {
            this.state.name = e.target.value;
            this.setState({});
        }
    }

    BackPage = () => {
        this.state.searchData.PageNumber = this.state.searchData.PageNumber - 1;
        this.state.paging = true;
        this.setState({})
        this.dataTable(this.state.searchData)
    }

    NextPage = () => {
        this.state.searchData.PageNumber = this.state.searchData.PageNumber + 1;
        this.state.paging = true;
        this.setState({})
        this.dataTable(this.state.searchData)
    }

    // handleInputChange = (e, str, val) => {
    //     if (val == "Name") {
    //         str.Name = e.target.value.trim();
    //         this.put_data(str, str.Id)
    //         this.setState({ index: 0 })
    //     }
    //     this.state.dataList.CommonRoles.sort((a, b) => {
    //         return a.Id - b.Id;
    //     });
    //     this.setState({})
    //     this.setState({ HoverId: 0, index: 0, HoverId1: 0, FocusId1: 0 })
    // }

    async postDataBlur(e, str, val) {
        this.setState({
            nameError: true,
        })
        if (this.state.isOnChange == true) {
            this.setState({
                isOnChange: false
            })
            let dataName = e.target.value.trim();
            if (dataName != "") {
                if ((str.Id == 0 && this.state.typeId != 0) || str.Id != 0) {
                    let url = API.verifyDuplicate_Roles + dataName
                    try {
                        let response = await axios.get(url);
                        if (response?.data == true) {
                            let index = this.state.existId.filter(item => item !== str.Id);
                            this.setState({
                                existId: index
                            })
                            if (str.Id == 0 && this.state.typeId != 0) {
                                let data = {
                                    "Name": dataName,
                                    "TypeId": this.state.typeId
                                }
                                this.post_data(data)
                            } else if (str.Id != 0) {
                                str.Name = dataName;
                                this.setState({ HoverId: 0, index: 0, HoverId1: 0, FocusId1: 0 })
                                this.put_data(str, str.Id)
                                this.state.dataList?.YardData?.sort((a, b) => {
                                    return a.Id - b.Id;
                                });
                            }
                        } else if (response?.data == false) {
                            let data = [...this.state.existId];
                            data.push(str.Id);
                            this.setState({
                                existId: data
                            })
                        }
                    } catch (e) {

                    }
                }
            }
            else if (dataName == "") {
                if (str.Id != 0) {
                    str.Name = dataName;
                    this.put_data(str, str.Id)
                    this.setState({ HoverId: 0, index: 0, HoverId1: 0, FocusId1: 0 })
                    this.state.dataList?.YardData?.sort((a, b) => {
                        return a.Id - b.Id;
                    });
                }
                let index = this.state.existId.filter(item => item !== str.Id);
                this.setState({
                    existId: index
                })
            }
            this.setState({})
        }
        else {
            this.setState({
                HoverId: 0,
                index: 0
            })
        }
    }

    roleChange = (e, val) => {
        let id = parseInt(e.value?.split(',')[0]);
        let data = {
            "Name": val.Name,
            "TypeId": id
        }
        this.state?.dataList?.CommonRoles?.map((i) => (
            i.Id == val.Id ? i.TypeId = id : <></>
        ))
        this.put_data(data, val.Id)
        this.setState({
            HoverId1: 0,
            FocusId1: 0
        })
    }

    async roleChangePost(e, val) {
        this.setState({
            typeId: parseInt(e.value?.split(',')[0]),
            nameError: true
        })
        if (this.state.name?.trim() != "" && parseInt(e.value?.split(',')[0]) != 0) {
            let url = API.verifyDuplicate_Roles + this.state.name?.trim()
            try {
                let response = await axios.get(url);
                if (response?.data == true) {
                    let index = this.state.existId.filter(item => item !== val.Id);
                    this.setState({
                        existId: index
                    })
                    let data = {
                        "Name": this.state.name,
                        "TypeId": parseInt(e.value?.split(',')[0])
                    }
                    this.post_data(data)
                } else if (response?.data == false) {
                    let data = [...this.state.existId];
                    data.push(val.Id);
                    this.setState({
                        existId: data
                    })
                }
            } catch (e) {

            }
        }
    }

    render() {
        let { classes, menuToggle } = this.props;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row border-bottom w-100 mt-4">
                                <div className="col-6 mt-auto">
                                    <List className="pt-3 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={() => this.sidebar()} >
                                            <ListItemText id="MASDATA2" className='  textNaviIcon' primary="Master Data" />
                                            <NavigateNextIcon id="MASDATA22" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-6 pt-2 mt-5">
                                    <h4>Roles</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="ml-auto" style={{ overflowX: "hidden", backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    <div className="row" style={{ margin: this.state.isMobile ? "auto" : "5px" }}>
                        <div className="row px-3">
                            <div className="col-10 p-2">
                                {this.state.isMobile ? <></> : <h6>Roles</h6>}
                            </div>
                        </div>
                        <div className="col-12 col-lg-12 col-md-12 col-sm-12 col-xl-12">
                            <div className="table-responsive mb-5" style={{ width: "100%" }}>
                                <table id="" className="table table-borderless border-top border-bottom border-left border-right">
                                    <thead>
                                        <tr className="table-active">
                                            <th className="border-top border-right border-left" width="49%" style={{ minWidth: '49%', maxWidth: '49%' }}><span className="spandoc-thead">Role</span></th>
                                            <th className="border-top border-right" width="48%" style={{ minWidth: '48%', maxWidth: '48%' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Type</span></th>
                                            <th className="border-top border-right" onClick={() => this.setState({ content: !this.state.content })} width="3%" style={{ minWidth: '3%', maxWidth: '3%' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Action</span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state?.dataList?.CommonRoles?.length > 0 ?
                                            <>{this.state?.dataList?.CommonRoles && this.state?.dataList?.CommonRoles?.map((i, index) => (
                                                i.Id != 0 ?
                                                    <tr className="border-top">
                                                        <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                            <div className={(this.state.HoverId == i.Id || this.state.index == i.Id || i.Name == "" || this.state.existId?.includes(i.Id) == true) ? "border-bg" : "border-bg-none"}>
                                                                <CssTextFieldRow
                                                                    multiline
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    type="text"
                                                                    id={"actName" + i.Id}
                                                                    onMouseEnter={(e) => this.setState({ HoverId: i.Id })}
                                                                    onMouseLeave={(e) => this.setState({ HoverId: 0 })}
                                                                    style={{ height: $("#actName" + i.Id).outerHeight() > $("#actDesc" + i.Id).outerHeight() ? $("#actName" + i.Id).outerHeight() + 13 : $("#actDesc" + i.Id).outerHeight() + 13, marginTop: "-3px" }}
                                                                    onFocus={(e) => this.setState({ index: i.Id })}
                                                                    onChange={(e) => this.handleInputChange1(e, i, 'Name', index)}
                                                                    onBlur={(e) => this.postDataBlur(e, i, 'Name')}
                                                                    value={i.Name}
                                                                    InputProps={{
                                                                        className: `border-radius padding-space spandoc-tbody ${classes.inputfieldAlign}`
                                                                    }} />
                                                            </div>
                                                            {(i.Name == "") ?
                                                                <span className="pt-5" style={{ color: '#DD0000' }}>Role name is required</span> : <></>}
                                                            {(i.Name?.trim() != "" && this.state.existId?.includes(i.Id) == true) ?
                                                                <span className="pt-5 red-color">Role name is already exist</span> : <></>}
                                                        </td>
                                                        <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                            <div
                                                                onMouseEnter={(e) => this.setState({ HoverId1: i.Id })}
                                                                onMouseLeave={(e) => this.setState({ HoverId1: 0 })}
                                                            >
                                                                <Select
                                                                    options={this.state.rolesOptions || []}
                                                                    // defaultValue={[]}
                                                                    value={this.state.rolesOptions?.filter((r) => parseInt(r.value?.split(",")[0]) == parseInt(i.TypeId))}
                                                                    placeholder=""
                                                                    classNamePrefix={(this.state.HoverId1 == i.Id || this.state.FocusId1 == i.Id) ? "rolesSelect" : "rolesSelectBorderNone"}
                                                                    menuPosition="fixed"
                                                                    menuPlacement="auto"
                                                                    isMulti={false}
                                                                    isSearchable={true}
                                                                    onChange={(e) => this.roleChange(e, i)}
                                                                    onFocus={(e) => this.setState({ FocusId1: i.Id })}
                                                                    onBlur={(e) => this.setState({ FocusId1: 0 })}
                                                                />
                                                            </div>
                                                        </td>
                                                        <td className="align-middle text-center border-right"><img src={Delete} className="cursorPointer" onClick={() => { this.OpenPopup(i.Id) }} /></td>
                                                    </tr> : <></>
                                            ))}
                                                {this.state?.dataList.CommonRoles && this.state?.dataList.CommonRoles.map((i) => (
                                                    i.Id == 0 ?
                                                        <tr className="border-top">
                                                            <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                                <CssTextFieldLast
                                                                    multiline
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    type="text"
                                                                    id="actName"
                                                                    onChange={(e) => this.handleRoleNameChange(e, i, 'Name')}
                                                                    onBlur={(e) => this.postDataBlur(e, i, 'Name')}
                                                                    value={this.state.name}
                                                                    InputProps={{
                                                                        className: `border-radius padding-space-roles spandoc-tbody ${classes.inputfieldAlign}`
                                                                    }} />
                                                                {((this.state.name.trim() == "" && this.state.typeId != 0 && this.state.nameError == true)) ?
                                                                    <span className="pt-5" style={{ color: '#DD0000' }}>Role name is required</span> : <></>}
                                                                {(this.state.name?.trim() != "" && this.state.existId?.includes(i.Id) == true) ?
                                                                    <span className="pt-5 red-color">Role name is already exist</span> : <></>}
                                                            </td>
                                                            <td className={`${window.innerWidth < 1000 ? "act-desc" : ""} border-right border-left`} style={{ minWidth: '49%', maxWidth: '49%' }}>
                                                                <Select
                                                                    options={this.state.rolesOptions || []}
                                                                    placeholder=""
                                                                    classNamePrefix={"rolesSelect"}
                                                                    menuPosition="fixed"
                                                                    menuPlacement="auto"
                                                                    isMulti={false}
                                                                    isSearchable={true}
                                                                    onChange={(e) => this.roleChangePost(e, i)}
                                                                    onFocus={(e) => this.setState({ FocusId1: i.Id })}
                                                                    onBlur={(e) => this.setState({ FocusId1: 0 })}
                                                                />
                                                                {((this.state.name.trim() != "" && this.state.typeId == 0 && this.state.nameError == true)) ?
                                                                    <span className="pt-5" style={{ color: '#DD0000' }}>Role type is required</span> : <></>}
                                                            </td>
                                                            <td className="align-middle text-center border-right">
                                                            </td>
                                                        </tr> : <></>
                                                ))}</> :
                                            <tr>
                                                <td className="border-top border-left border-right text-center align-middle" colSpan={3}><h6>No data to display</h6></td>
                                            </tr>}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div className={`${classes.paginationAlign}`}>
                        <div className={`${classes.paginationItem}`}>
                            {this.state.searchData.PageNumber == 1 ? <></> :
                                <ArrowBackIcon className={classes.arrow} onClick={() => this.BackPage()} />}
                            <span className="pl-2 pr-2">Page {this.state.searchData.PageNumber}</span>
                            {(this.state.searchData.PageNumber == this.state.dataList?.pagination?.PageCount) || (this.state.dataList?.pagination?.PageCount == 0) ? <></> :
                                <ArrowForwardIcon className={classes.arrow} onClick={() => this.NextPage()} />}
                        </div>
                    </div>

                    <div class="modal fade p-5 mt-5" id="deletepopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Are you sure you want to delete?</h5></div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={() => this.DeleteItem()}><span className="" >Delete</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#deletepopup").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
    };
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(LViewRoles))
);
